import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import AddNysc from "./AddNysc";

function Nysc({ nyscData, refetchNysc, refetchStatus }) {
  const { t } = useTranslation();
  const [openEditNyscModal, setOpenEditNyscModal] = useState(false);
  const [addNyscModal, setAddNyscModal] = useState(false);

  return (
    <div>
      <div className="font-semibold text-xl text:darkBlue flex items-center gap-x-24">
        {t('nysc-object.title')}
        <div
          className="cursor-pointer bi bi-plus-circle border border-primary text-primary p-2 rounded-lg text-base font-semibold"
          onClick={() => setAddNyscModal(true)}
          data-testid="add-nysc-cert-details"
        >
          &nbsp;{t('nysc-object.add-button')}
        </div>
      </div>
      {addNyscModal && (
        <AddNysc
          closeModal={setAddNyscModal}
          refetchNysc={refetchNysc}
          refetchStatus={refetchStatus}
        />
      )}
      {nyscData?.data === null && (
        <div className="mt-10 text-center text-base font-medium text-lightGrey">
          {t('nysc-object.update-message')}
        </div>
      )}

      {
        <>
          <div className="my-4">
            <span className="text-base">
              {nyscData?.data?.status === 'completed' 
                ? t('nysc-object.certificate.number') 
                : t('nysc-object.certificate.call-up')}
            </span>:{" "}
            <span className="font-medium text-lg">
              {" "}
              {nyscData?.data?.status === 'completed'
                ? nyscData?.data?.certificate_number
                : nyscData?.data?.call_up_number}
            </span>
          </div>
          <div>
            <span className="text-base">{t('nysc-object.pop-date')}</span>:{" "}
            <span className="font-medium text-lg">
              {`${new Date(nyscData?.data?.pop_date).toLocaleDateString('en-ng')}`}
            </span>
          </div>
        </>
      }
    </div>
  );
}

export default Nysc;
